module.exports = __webpack_public_path__ + "img/Home_08.c94c364c.jpg";